import { Box, Card, CardBody, CardFooter, CardHeader, Image, Text } from "grommet";
import React from "react";
import ParallaxTilt2 from "../components/ParallaxTilt2";
import { BadgeViewModel } from "./BadgeStore";

export const BadgeCard = ({ badge, width, onClick, children }: { badge: BadgeViewModel; width?: number; onClick: any; children?: any }) => {
    return (
        <>
            {/* <Link to={`/badge/${badge.id}`} style={{ textDecoration: "none" }}> */}
            <ParallaxTilt2>
                <Card width={!!width ? width + "px" : "250px"} height={!!width ? width * 1.5 + "px" : "375px"} background="background" onClick={onClick}>
                    <CardBody align="center" justify="center">
                        <Box align="center">
                            <Image src={badge.logoURI} fit="contain" />
                        </Box>
                    </CardBody>
                    <CardHeader pad="small" justify="center" fill="horizontal">
                        <Text textAlign="center">{badge.name}</Text>
                    </CardHeader>
                    <CardFooter pad="small" background="background-front">
                        <Box direction="row" gap="small" fill="horizontal">
                            {children}
                        </Box>
                    </CardFooter>
                </Card>
            </ParallaxTilt2>
            {/* </Link> */}
        </>
    );
};
